import styled, { css } from 'styled-components'

export const SvgSC = styled.svg`
  ${({ theme: { color } }) => css`
    --primaryColor: ${color.blue.primary};
    --secondaryColor: ${color.blue.tint25};
    --blue75: ${color.blue.tint75};
    --bgColor: ${color.background.primary};
  `}
`
